import React, {Component} from 'react';
import {Button} from 'semantic-ui-react';
import localDB from "../../data/localDB";
import {withRouter} from "react-router-dom";

class GoToSale extends Component {

    goSale = (sale) => {
        let new_sale =  Object.assign({}, sale);
        if(new_sale.client_id){
            new_sale.client = {
                id: new_sale.client_id,
                identification: new_sale.client_identification,
                full_name: new_sale.client
            }
        }

        localDB.saveSaleStorage(new_sale, 'sale');
        this.props.history.push(`/sale/view/${new_sale.billing_number}`);
    };

    render() {
        return <Button content={this.props.type !== 9 ? 'Ver Pedido':'Ver Ingreso'} onClick={() => this.goSale(this.props)} fluid primary icon='food' labelPosition='left' />
    }
}
export default withRouter(GoToSale);



// WEBPACK FOOTER //
// ./src/components/sale/GoToSale.js